import { render, staticRenderFns } from "./postTest.vue?vue&type=template&id=520bd3ca&scoped=true&"
import script from "./postTest.vue?vue&type=script&lang=js&"
export * from "./postTest.vue?vue&type=script&lang=js&"
import style0 from "./postTest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./postTest.vue?vue&type=style&index=1&id=520bd3ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bd3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('520bd3ca', component.options)
    } else {
      api.reload('520bd3ca', component.options)
    }
    module.hot.accept("./postTest.vue?vue&type=template&id=520bd3ca&scoped=true&", function () {
      api.rerender('520bd3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\evaluation\\postTest.vue"
export default component.exports